"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _themeContants = require("../../../constants/themeContants");

var _theming = require("../../../theming");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Toggle = function Toggle(_ref) {
  var children = _ref.children,
      id = _ref.id,
      group = _ref.group,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      className = _ref.className,
      defaultChecked = _ref.defaultChecked,
      variant = _ref.variant,
      otherProps = _objectWithoutProperties(_ref, ["children", "id", "group", "disabled", "onChange", "className", "defaultChecked", "variant"]);

  return _react["default"].createElement(ToggleWrapper, {
    htmlFor: id,
    className: className,
    variant: variant
  }, _react["default"].createElement(ToggleInput, _extends({
    id: id,
    disabled: disabled,
    type: "checkbox",
    name: group,
    onChange: onChange,
    defaultChecked: defaultChecked,
    variant: variant
  }, otherProps)), _react["default"].createElement(ToggleElement, {
    variant: variant
  }, _react["default"].createElement("span", null, children)));
};

Toggle.themeProps = {
  wrapper: {
    name: "TOGGLE",
    description: "Toggle style",
    type: _themeContants.themePropTypes.style
  },
  toggleElement: {
    name: "TOGGLE_ELEMENT",
    description: "Toggle element style",
    type: _themeContants.themePropTypes.style
  },
  input: {
    name: "TOGGLE_INPUT",
    description: "Toggle input style",
    type: _themeContants.themePropTypes.style
  },
  checked: {
    name: "  TOGGLE_ELEMENT_CHECKED",
    description: "Toggle element checked style",
    type: _themeContants.themePropTypes.style
  }
};

var ToggleWrapper = _styledComponents["default"].label.withConfig({
  displayName: "Toggle__ToggleWrapper",
  componentId: "sc-2sg60o-0"
})(["min-height:", ";padding-top:", ";padding-bottom:", ";display:block;", ";"], _theming.targetSize.normal, _theming.spacing.tiny, _theming.spacing.tiny, (0, _theming.applyVariants)(Toggle.themeProps.wrapper));

var ToggleElement = _styledComponents["default"].div.withConfig({
  displayName: "Toggle__ToggleElement",
  componentId: "sc-2sg60o-1"
})(["background-color:", ";border-radius:2em;padding:2px;transition:all 0.4s ease;span{position:absolute;clip:rect(0,0,0,0);clip:rect(0 0 0 0);}&:after{border-radius:50%;background:", ";transition:all 0.2s ease;}", ";"], _theming.color.line, _theming.color.white, (0, _theming.applyVariants)(Toggle.themeProps.toggleElement));

var ToggleInput = _styledComponents["default"].input.withConfig({
  displayName: "Toggle__ToggleInput",
  componentId: "sc-2sg60o-2"
})(["position:absolute;clip:rect(0,0,0,0);clip:rect(0 0 0 0);&,&:after,&:before,& *,& *:after,& *:before,& + ", "{box-sizing:border-box;&::selection{background:none;}}+ ", "{{}outline:0;display:block;width:4em;height:2em;position:relative;cursor:pointer;user-select:none;&:after,&:before{position:relative;display:block;content:\"\";width:50%;height:100%;}&:after{left:0;}&:before{display:none;}}&:checked + ", "{background:", ";&:after{transform:translateX(100%);}", ";}", ";"], ToggleElement, ToggleElement, ToggleElement, _theming.color.green, (0, _theming.applyVariants)(Toggle.themeProps.checked), (0, _theming.applyVariants)(Toggle.themeProps.input));

Toggle.propTypes = {
  disabled: _propTypes["default"].bool,
  group: _propTypes["default"].string,
  id: _propTypes["default"].string.isRequired,
  input: _propTypes["default"].any,
  onChange: _propTypes["default"].func,
  className: _propTypes["default"].string,
  defaultChecked: _propTypes["default"].bool,
  children: _themeContants.commonPropTypes.children
};
Toggle.defaultProps = {
  disabled: false,
  input: {},
  onChange: null,
  className: "",
  defaultChecked: false,
  children: ""
};
var _default = Toggle;
exports["default"] = _default;